;(function() {
  'use strict'

  angular.module('core.surveyTemplateGrid', [])
})()
